import _ from 'lodash';
import vendors from './helpers/vendor-prefixes';
// This mixin generates the full css from each droplets mediaQueries
// prop. It builds all media queries as well as vendor prefixes. This is
// the CSS that get's rendered for each droplet on the static site, as
// well as the editor preview

// API:
// 1) You will either need to pass in 1 droplet or an array of droplets (cols for example).
// in the generateCSS function. drps: drp.droplets or drp: drp
// 2) your droplet(s) will need to have an :id set using your props droplet id and you will
// need to prefix it with 'drp-'
// 3) your droplet / droplets will need the following "mediaQueries" property in it's props.
// see below example:
// mediaQueries: [
//   {
//     property: 'width',
//     unit: '%', // not required
//     desktop: 'default', // default values get ignored
//     tablet: 'default', // unless dynamically changed
//     mobile: '100',
//   },
//   or if custom selector, follow this format
//   {
//     global: true, // optional, only if global reposition is needed
//     selector: '.myClass .otherClass',
//     noId: false, use this if you do not want the nested droplet id (aka global rules)
//     properties: [
//      {
//        property: 'border-color',
//        desktop: 'default',
//        tablet: 'default',
//        mobile: 'default',
//      },
//      {
//        property: 'background-color',
//        desktop: 'default',
//        tablet: 'default',
//        mobile: 'default', // changed value
//      },
//    ],
//   },
// ],
// 4) then in your state mutation, mutate the media query values you want
const cssGenerator = {
  methods: {
    generateCSS(params) {
      const viewport = window.drzzle.viewports;
      // we need to ensure this doesn't run inside the drp container btn's
      const scope = this;
      if (this.$parent.$options._componentTag !== 'droplet-container-btn') {
        if (!this.$el && !params.styleEl) {
          return;
        }
        const domEl = params.styleEl || this.$el;
        let styleTags = domEl.previousSibling;
        const styleTagsSet = styleTags !== null && styleTags.tagName === 'STYLE';
        const droplet = params.drp;
        const droplets = params.drps;
        const hideTags = params.hideTags;
        if (!styleTagsSet && !hideTags) {
          const newStyleTags = document.createElement('style');
          newStyleTags.setAttribute('data-source', 'picazzo');
          domEl.parentNode.insertBefore(newStyleTags, domEl);
          styleTags = newStyleTags;
        }
        // callback for building out all of the rules
        const buildRules = (d) => {
          let liveStyles = '';
          let editorStyles = '';
          let id;
          // get correct id type
          if (!_.isUndefined(d) && !_.isUndefined(d.id)) {
            id = d.id;
          }
          if (!_.isUndefined(d) && !_.isUndefined(d._id)) {
            id = d._id;
          }
          _.forEach(d.mediaQueries, (mq) => {
            let selector = mq.selector;
            if (selector && selector === ':reveal') {
              selector = '.drzAnimation-onReveal-row';
            } else if (selector && selector.match(/:reveal/gi)) {
              const gridClass = '> .grid-container > .grid-column';
              const gridReg = new RegExp(gridClass, 'gi');
              const isGridCol = selector.match(gridReg);
              const revealClass = '.drzAnimation-onReveal';
              selector = isGridCol ? `${gridClass}${revealClass}` : revealClass;
            } else if (selector && selector.match(/:scroll/g)) {
              // this is for currently for nav specific droplets
              const nonState = selector.replace(/:scroll/g, '');
              if (nonState === '.drzNav') {
                selector = '.drzNav.drzNav-sticky-set';
              } else if (nonState.match(/.drzNav\s/g)) {
                selector = nonState.replace(/.drzNav\s/g, '.drzNav.drzNav-sticky-set ');
              } else {
                selector = `.drzNav-sticky-set ${nonState}`;
              }
            }
            const rules = {
              desktop: '',
              tablet: '',
              mobile: '',
            };
            const editorRules = {
              desktop: '',
              tablet: '',
              mobile: '',
            };
            let cssSelector = '';
            const actions = {
              assetCheck(value) {
                let servePath = value;
                if (value.match(/url\(/)) {
                  const url = new RegExp(/url\(([^)]+)\)/, 'gi');
                  const original = value;
                  const mediaString = servePath.match(url)[0];
                  const file = mediaString.replace(/url\('|'\)|url\(|\)/gi, '');
                  const replace = original.replace(url, `url(${scope._servePrefix(file)}${file})`);
                  servePath = replace;
                }
                return servePath;
              },
              buildMediaQueries(obj) {
                let unit = '';
                if (obj.unit) {
                  unit = obj.unit;
                }
                ['desktop', 'tablet', 'mobile'].forEach((viewport) => {
                  if (obj[viewport] !== 'default') {
                    let value = `${obj[viewport]}${unit}`;
                    // we need to override things for scroll reveal transitions
                    if (selector === '.drzAnimation-revealing') {
                      const all = obj.property === 'transition' ? 'all ' : '';
                      value = `${all}${obj[viewport]}${unit} !important`;
                    }
                    const editorValue = actions.assetCheck(value);
                    const prefixes = vendors.needsPrefix(obj.property, 'properties');
                    const valuePrefixes = vendors.needsValuePrefix(obj.property, 'values', value);
                    if (prefixes && prefixes.length > 0) {
                      prefixes.forEach((prefixedProp) => {
                        rules[viewport] += `${prefixedProp}:${value};`;
                        editorRules[viewport] += `${prefixedProp}:${editorValue};`;
                      });
                    } else if (valuePrefixes && valuePrefixes.length > 0) {
                      valuePrefixes.forEach((rule) => {
                        rules[viewport] += `${rule.property}:${rule.value};`;
                        editorRules[viewport] += `${rule.property}:${rule.value};`;
                      });
                    } else {
                      rules[viewport] += `${obj.property}:${value};`;
                      editorRules[viewport] += `${obj.property}:${editorValue};`;
                    }
                  }
                });
              },
            };
            // if there is a custom selecter, loop through it's properties
            if (typeof selector === 'string') {
              const buffer = selector.match(/^:/gi) || selector === '.drzAnimation-onReveal-row' ? '' : ' ';
              cssSelector = (droplet && droplet.globalCSS) || mq.noId ? selector : `#drp-${id}${buffer}${selector}`;
              cssSelector = cssSelector.replace(/,/g, `, #drp-${id} `);
              const properties = mq.properties;
              _.forEach(properties, (prop) => {
                actions.buildMediaQueries(prop);
              });
            } else {
              // proceed with non selector format or global rule
              cssSelector = (droplet && droplet.globalCSS) || mq.noId ? '' : `#drp-${id}`;
              actions.buildMediaQueries(mq);
            }
            let editorCSS = '';
            let liveCSS = '';
            const addViewports = (sel) => {
              if (rules.desktop !== '') {
                editorCSS += `${sel} {${editorRules.desktop}}\n`;
                liveCSS += `${sel} {${rules.desktop}}\n`;
              }
              if (rules.tablet !== '') {
                editorCSS += `@media ${viewport.tablet} {${sel} {${editorRules.tablet}}}\n`;
                liveCSS += `@media screen and (min-width:601px) and (max-width:992px) {${sel} {${rules.tablet}}}\n`;
              }
              if (rules.mobile !== '') {
                editorCSS += `@media ${viewport.mobile} {${sel} {${editorRules.mobile}}}\n`;
                liveCSS += `@media screen and (min-width:50px) and (max-width:600px) {${sel} {${rules.mobile}}}\n`;
              }
            };
            const prefixes = vendors.needsPrefix(cssSelector, 'selectors');
            // for selectors that need a prefix (aka newer psuedo types)
            if (prefixes && prefixes.length) {
              prefixes.forEach((sel) => {
                addViewports(sel);
              });
            } else {
              addViewports(cssSelector);
            }
            editorStyles += editorCSS;
            liveStyles += liveCSS;
          });
          return { editorStyles, liveStyles };
        };
        let editorSet = ''; // this will be shown in editor only, with spoofed viewports
        let liveSet = ''; // used to save pageCSS. this will be in shipped template
        // check if passed a droplet or an array of sub droplets
        if (droplet) {
          // single droplet passed
          const build = buildRules(droplet);
          liveSet = build.liveStyles;
          editorSet = build.editorStyles;
        } else if (droplets) {
          // array of droplets passed
          _.forEach(droplets, (drp) => {
            const build = buildRules(drp);
            liveSet += build.liveStyles;
            editorSet += build.editorStyles;
          });
        }
        if (!hideTags) {
          styleTags.innerHTML = editorSet;
        }

        const payload = `<style type="text/css">${liveSet}</style>`;
        let item;
        if (params.$vm) {
          item = params.$vm;
        } else {
          const node = droplet && droplet.globalCSS ? 'currentSite' : 'droplet';
          item = this[node];
        }
        const nodeCSS = item.pageCSS;
        // send this style to the component for state but only if there are changes.
        // this will prevent the built-in "update" hook from always sending this off
        if (nodeCSS !== payload) {
          this.saveCssString(payload, params, item);
        }
      }
    },
    async saveCssString(styling, params, drp) {
      await this.$store.dispatch('setDropletVal', {
        drp,
        key: 'pageCSS',
        val: styling,
      });
    },
  },
};

export { cssGenerator };



// WEBPACK FOOTER //
// ./src/mixins/css-generator.js